<template>
  <div class="woo-help-outer">
    <div class="woo-help-view">
      <helper-playlist urlAware="true" :onCloseHelp="onCloseHelp"/>
    </div>
  </div>
</template>
<script>
import HelperPlaylist from '../components/HelperPlaylist.vue';

export default {
  components: { HelperPlaylist },
  name: 'HelpView',
  methods: {
    onCloseHelp() {
      this.$router.replace('/');
    }
  }
}
</script>

<style lang="scss">
  .v-icon {
    color: black;
  }

  .woo-help-outer {
    padding: 20px;
    height: 100%;
  }

  .woo-help-view {
    max-width: 29rem;
    margin: 0 auto;
    background-color: #f2f2f2 !important;
    padding: 0px 0px !important;
    position: relative;
    border: 1px solid #eee;
    border-radius: 12px;
    height: 100%;
  }

  .woo-help-topic-wrapper {
    background-color: transparent !important;
  }

  .woo-help-view-header {
    padding: 0px 30px !important;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 768px) {
    .woo-help-outer {
      padding: 0px;
    }

    .woo-help-view {
      margin: 0;
      border-radius: 0px;
    }
  }
</style>